import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

interface EossBannerProps {
  desktop: string
  mobile: string
}
export const EossBanner = ({ desktop, mobile }: EossBannerProps) => {
  if (!desktop || !mobile) return null
  return (
    <picture>
      <source
        srcSet={ImageHelper.getImageUrlCdn(mobile)}
        media='(max-width: 768px)'
      />
      <Image
        src={ImageHelper.getImageUrlCdn(desktop)}
        alt=''
        width={100}
        height={100}
        className='w-full rounded-2xl object-cover'
      />
    </picture>
  )
}
